import { useContext } from "react";
import { AppContext } from "core/context";

function useUpdatePage() {
    const appContext = useContext(AppContext);

    const updateTitle = (title: string, usePrefix = true) => {
        appContext.updateTitle(title, usePrefix);
    }

    const updateBodyCssName = (cssName: string, append = false) => {
        if (append) {
            appContext.appendBodyCssName(cssName);
            return;
        }

        appContext.updateBodyCssName(cssName);
    }


    return [updateTitle, updateBodyCssName];
}

export default useUpdatePage;
